var map = {
	"./audi.svg": 5344,
	"./benz.svg": 51364,
	"./bmw.svg": 19475,
	"./facebook.svg": 41615,
	"./ferrari.svg": 26502,
	"./ford.svg": 19960,
	"./google.svg": 90710,
	"./honda.svg": 19847,
	"./hyundai.svg": 86351,
	"./kia-new.svg": 7689,
	"./lamborghini.svg": 85321,
	"./toyota.svg": 52529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42975;